(function(){
var qsdEnglish=!/^zh(?:-|$)/i.test(document.documentElement.lang||'en');
var qsdCopy={"强肾丹产品说明书":"Qiangshen Dan Product Instructions","购买四颗以上免运费。":"Free shipping on purchases of four or more pills.","运费说明：":"Shipping:"};
var qsdTraditional=/^zh-(?:tw|hk|mo|hant)(?:-|$)/i.test(document.documentElement.lang||'en');
var qsdTraditionalCopy={"强肾丹产品说明书":"強腎丹產品說明書","购买四颗以上免运费。":"購買四顆以上免運費。","运费说明：":"運費說明："};
function qsdText(value){var copy=qsdEnglish?qsdCopy:qsdTraditional?qsdTraditionalCopy:null;return copy&&Object.prototype.hasOwnProperty.call(copy,value)?copy[value]:value}
var qsdNativeRoots={"https://1a8uhf-qg.myshopify.com":{"en":"","zh-CN":"/zh-cn","zh-TW":"/zh-tw"},"https://kidneypill.com":{"en":"","zh-CN":"/zh-hans","zh-TW":"/zh-hant"}};
function qsdNativeRoot(){var map=qsdNativeRoots[location.origin]||qsdNativeRoots['https://kidneypill.com'];return map[qsdEnglish?'en':qsdTraditional?'zh-TW':'zh-CN']+'/'}
function qsdHref(input){
 if(window.QSDLocale&&typeof window.QSDLocale.href==='function')return window.QSDLocale.href(input);
 try{var u=new URL(input,location.origin);if(u.origin!==location.origin||qsdSigned(u)||!/^\/(?:(?:zh-hans|zh-hant|zh-cn|zh-tw|zh)\/)?(?:products|collections|pages|cart|checkout|account|search)(?:\/|$|\.)/.test(u.pathname))return input;
 var root=qsdNativeRoot();return root.replace(/\/?$/,'/')+u.pathname.replace(/^\/(?:(?:zh-hans|zh-hant|zh-cn|zh-tw|zh)\/)?/,'')+u.search+u.hash}catch(e){return input}
}
function qsdSigned(url){var signed=false;url.searchParams.forEach(function(value,key){if(/^(?:signature|hmac|token|key|logged_in_customer_id|state|code|shopify_sig|shopify_signature)$/i.test(key))signed=true});return signed}
function qsdLiveHref(next,original){if(qsdSigned(original))return original.pathname+original.search+original.hash;var u=new URL(next,location.origin),extra=[];if(original.search)original.search.slice(1).split('&').forEach(function(entry){var key=entry.split('=')[0];try{key=decodeURIComponent(key.replace(/\+/g,' '))}catch(e){}if(!u.searchParams.has(key))extra.push(entry)});return qsdHref(u.pathname+u.search+(extra.length?(u.search?'&':'?')+extra.join('&'):'')+original.hash)}
(function(){
  var menuToggle = document.querySelector("[data-mobile-menu-toggle]");
  var mobileMenu = document.querySelector("[data-mobile-menu]");
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener("click", function(){
      mobileMenu.classList.toggle("is-open");
    });
  }

  var mpMenuToggle = document.querySelector("[data-menu-toggle]");
  var mpMenu = mpMenuToggle ? document.getElementById(mpMenuToggle.getAttribute("aria-controls")) : null;
  if (mpMenuToggle && mpMenu) {
    mpMenuToggle.addEventListener("click", function(){
      var isOpen = !document.body.classList.contains("menu-open");
      document.body.classList.toggle("menu-open", isOpen);
      mpMenuToggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });
    mpMenu.querySelectorAll("a").forEach(function(link){
      link.addEventListener("click", function(){
        document.body.classList.remove("menu-open");
        mpMenuToggle.setAttribute("aria-expanded", "false");
      });
    });
  }

  (function(){
    var saleBar = document.querySelector("[data-sale-bar]");
    var countdown = saleBar && saleBar.querySelector("[data-sale-countdown]");
    var dismiss = saleBar && saleBar.querySelector("[data-sale-dismiss]");
    if (!saleBar || !countdown || !window.sessionStorage) return;
    var countdownKey = "lucmintSummerSaleEndsAt";
    var dismissedKey = "lucmintSummerSaleDismissed";
    var duration = 14400 * 1000;
    var timer;
    var endsAt = Number(window.sessionStorage.getItem(countdownKey));
    if (window.sessionStorage.getItem(dismissedKey) === "true") {
      saleBar.hidden = true;
      return;
    }
    if (!Number.isFinite(endsAt) || endsAt <= Date.now()) {
      endsAt = Date.now() + duration;
      window.sessionStorage.setItem(countdownKey, String(endsAt));
    }
    function renderCountdown(){
      var remaining = Math.max(0, endsAt - Date.now());
      if (remaining === 0) {
        endsAt = Date.now() + duration;
        window.sessionStorage.setItem(countdownKey, String(endsAt));
        remaining = duration;
      }
      var totalSeconds = Math.floor(remaining / 1000);
      var hours = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
      var minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
      var seconds = String(totalSeconds % 60).padStart(2, "0");
      countdown.textContent = hours + ":" + minutes + ":" + seconds + " left";
    }
    renderCountdown();
    timer = window.setInterval(renderCountdown, 1000);
    if (dismiss) {
      dismiss.addEventListener("click", function(){
        window.clearInterval(timer);
        window.sessionStorage.setItem(dismissedKey, "true");
        saleBar.hidden = true;
      });
    }
  })();

  (function(){
    if (window.__lucmintDeliveryEstimateReady) return;
    window.__lucmintDeliveryEstimateReady = true;
    var dayInMs = 1440 * 60 * 1000;
    var deliveryDateLocale = qsdEnglish ? "en-US" : qsdTraditional ? "zh-TW" : "zh-CN";
    var longDateFormatter = new Intl.DateTimeFormat(deliveryDateLocale, {
      month: "short",
      day: "numeric",
      year: "numeric"
    });
    var shortDateFormatter = new Intl.DateTimeFormat(deliveryDateLocale, {
      month: "short",
      day: "numeric"
    });
    var dayDateFormatter = new Intl.DateTimeFormat(deliveryDateLocale, { day: "numeric" });
    function addDays(date, days){
      var next = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12, 0, 0, 0);
      next.setDate(next.getDate() + days);
      return next;
    }
    function numericSetting(root, name, fallback){
      var value = Number(root.getAttribute(name));
      return Number.isFinite(value) ? value : fallback;
    }
    function formatRange(start, end){
      if (start.getFullYear() === end.getFullYear() && start.getMonth() === end.getMonth()) {
        return shortDateFormatter.format(start) + " \u2013 " + dayDateFormatter.format(end);
      }
      return shortDateFormatter.format(start) + " \u2013 " + shortDateFormatter.format(end);
    }
    function setText(root, selector, value){
      var element = root.querySelector(selector);
      if (element) element.textContent = value;
    }
    function updateEstimate(root){
      var now = new Date();
      var cutoff = new Date(now);
      cutoff.setHours(23, 59, 59, 999);
      var remainingMinutes = Math.max(0, Math.ceil((cutoff.getTime() - now.getTime()) / 60000));
      var remainingHours = Math.floor(remainingMinutes / 60);
      var minutes = remainingMinutes % 60;
      var pad = function(value){ return String(value).padStart(2, "0"); };
      var processingMin = numericSetting(root, "data-processing-min-days", 1);
      var processingMax = numericSetting(root, "data-processing-max-days", 3);
      var deliveryMin = numericSetting(root, "data-delivery-min-days", 5);
      var deliveryMax = numericSetting(root, "data-delivery-max-days", 7);
      var processingStart = addDays(now, processingMin);
      var processingEnd = addDays(now, processingMax);
      var deliveryStart = addDays(now, deliveryMin);
      var deliveryEnd = addDays(now, deliveryMax);
      setText(root, "[data-eta-hours]", pad(remainingHours));
      setText(root, "[data-eta-minutes]", pad(minutes));
      setText(root, "[data-eta-purchase-date]", shortDateFormatter.format(now));
      setText(root, "[data-eta-processing-range]", formatRange(processingStart, processingEnd));
      setText(root, "[data-eta-delivery-range]", formatRange(deliveryStart, deliveryEnd));
      setText(root, "[data-eta-delivery-start]", longDateFormatter.format(deliveryStart));
      setText(root, "[data-eta-delivery-end]", longDateFormatter.format(deliveryEnd));
    }
    function updateAllEstimates(){
      document.querySelectorAll("[data-delivery-estimate]").forEach(updateEstimate);
    }
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", updateAllEstimates, { once: true });
    } else {
      updateAllEstimates();
    }
    document.addEventListener("shopify:section:load", updateAllEstimates);
    window.setInterval(updateAllEstimates, Math.min(dayInMs, 15000));
  })();

  function updateCountdown(){
    var now = new Date();
    var end = new Date(now);
    end.setHours(23, 59, 59, 999);
    var diff = Math.max(0, end.getTime() - now.getTime());
    var days = Math.floor(diff / 864e5);
    var hours = Math.floor(diff / 36e5);
    var minutes = Math.floor(diff % 36e5 / 6e4);
    var seconds = Math.floor(diff % 6e4 / 1000);
    var pad = function(n){ return String(n).padStart(2, "0"); };
    document.querySelectorAll("[data-count-days]").forEach(function(el){ el.textContent = "00"; });
    document.querySelectorAll("[data-count-hours]").forEach(function(el){ el.textContent = pad(hours); });
    document.querySelectorAll("[data-count-minutes]").forEach(function(el){ el.textContent = pad(minutes); });
    document.querySelectorAll("[data-count-seconds]").forEach(function(el){ el.textContent = pad(seconds); });
    document.querySelectorAll("[data-product-count-days]").forEach(function(el){ el.textContent = String(days); });
    document.querySelectorAll("[data-product-count-hours]").forEach(function(el){ el.textContent = String(hours); });
    document.querySelectorAll("[data-product-count-minutes]").forEach(function(el){ el.textContent = String(minutes); });
    document.querySelectorAll("[data-product-count-seconds]").forEach(function(el){ el.textContent = String(seconds); });
  }
  updateCountdown();
  window.setInterval(updateCountdown, 1000);


  function normalizeLegacyBrandText(value){
    return String(value || "")
      .replace(/service@service\.atelieroil\.com\s*&\s*hello@atelieroil\.com/gi, "sales@hymnart.net")
      .replace(/service@service\.hymnart\.net\s*&\s*hello@hymnart\.net/gi, "sales@hymnart.net")
      .replace(/service@service\.hymnart\.net/gi, "sales@hymnart.net")
      .replace(/support@atelieroil\.com/gi, "sales@hymnart.net")
      .replace(/contact@atelieroil\.com/gi, "sales@hymnart.net")
      .replace(/info@atelieroil\.com/gi, "info@hymnart.net")
      .replace(/hello@atelieroil\.com/gi, "info@hymnart.net")
      .replace(/hello@hymnart\.net/gi, "info@hymnart.net")
      .replace(/sales@hymnart\.net/gi, "sales@hymnart.net")
      .replace(/www\.atelieroil\.com/gi, "www.hymnart.net")
      .replace(/atelieroil\.com/gi, "hymnart.net")
      .replace(/LEEBON\s+LIMITED\s*\(\s*trading as\s+AtelierOil\s*\)/gi, "JD Media (trading as HymnArt)")
      .replace(/LEEBON\s+LIMITED\s*\(\s*trading as\s+HymnArt\s*\)/gi, "JD Media (trading as HymnArt)")
      .replace(/LEEBON\s+LIMITED/gi, "JD Media")
      .replace(/AtelierOil/gi, "HymnArt")
      .replace(/Atelier Oil/gi, "HymnArt")
      .replace(/82\s*James\s*Carter\s*Road,?\s*Mildenhall,?\s*IP28\s*7DE,?\s*United\s+Kingdom/gi, "Room 701, Shentie Ruicheng, Guangming District, Shenzhen, China")
      .replace(/Mildenhall,?\s*UnitA\s*，?\s*82\s*James\s*Carter\s*Road,?\s*Mildenhall,?\s*ENG,?\s*IP28\s*7DE,?\s*GB/gi, "Room 701, Shentie Ruicheng, Guangming District, Shenzhen, China")
      .replace(/UnitA\s*，?\s*82\s*James\s*Carter\s*Road,?\s*Mildenhall,?\s*ENG,?\s*IP28\s*7DE,?\s*GB/gi, "Room 701, Shentie Ruicheng, Guangming District, Shenzhen, China")
      .replace(/82\s*James\s*Carter\s*Road,?\s*Mildenhall,?\s*ENG,?\s*IP28\s*7DE,?\s*GB/gi, "Room 701, Shentie Ruicheng, Guangming District, Shenzhen, China")
      .replace(/Mildenhall,?\s*ENG,?\s*IP28\s*7DE,?\s*GB/gi, "Los Angeles, CA 90013, US")
      .replace(/\+1\s*\(?310\)?\s*997[-\s]?0089/gi, "+85252951915")
      .replace(/\+1（630）6470433/g, "+85252951915")
      .replace(/JD Media \(trading as hymnart\s*）/g, "JD Media (trading as HymnArt)")
      .replace(/JD Media \(trading as hymnart\)/g, "JD Media (trading as HymnArt)");
  }

  function cleanLegacyBrandText(root){
    root = root || document.body;
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function(node){
        if (!node.nodeValue || !/(AtelierOil|atelieroil|LEEBON|82\s*James|Mildenhall|IP28|service@service|hello@|\+1\s*\(?310\)?)/i.test(node.nodeValue)) return NodeFilter.FILTER_REJECT;
        var parent = node.parentElement;
        if (parent && /SCRIPT|STYLE|NOSCRIPT|TEXTAREA|INPUT/.test(parent.tagName)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function(node){
      var next = normalizeLegacyBrandText(node.nodeValue);
      if (next !== node.nodeValue) node.nodeValue = next;
    });
    root.querySelectorAll && root.querySelectorAll("a[href]").forEach(function(link){
      var href = normalizeLegacyBrandText(link.getAttribute("href"));
      if (href !== link.getAttribute("href")) link.setAttribute("href", href);
    });
  }

  cleanLegacyBrandText(document.body);
  document.addEventListener("DOMContentLoaded", function(){ cleanLegacyBrandText(document.body); });

  function updateLucmintFooterContact(){
    var contact = document.querySelector(".ao-footer__contact");
    if (!contact) return;
    contact.innerHTML = [
      '<p class="ao-footer-title">CONTACT</p>',
      '<p><strong>Pre-Sales Inquiries:</strong> <a href="mailto:info@lucmint.com">info@lucmint.com</a></p>',
      '<p><strong>After-Sales Support:</strong> <a href="mailto:sales@lucmint.com">sales@lucmint.com</a></p>',
      '<p><strong>Company Address:</strong> <span>Room 701, Shentie Ruicheng, Guangming District, Shenzhen, China</span></p>',
      '<p><strong>Support Hours:</strong> <span>Mon-Fri, 9:00-18:00 (GMT)</span></p>',
      '<p><strong>' + qsdText('运费说明：') + '</strong> <span>' + qsdText('购买四颗以上免运费。') + '</span></p>',
      '<p><strong>WhatsApp:</strong> <a href="https://wa.me/85252951915">+85252951915</a></p>'
    ].join("");
  }

  updateLucmintFooterContact();
  document.addEventListener("DOMContentLoaded", updateLucmintFooterContact);

  function removeKnownBlankProductImages(root){
    root = root || document;
    if (!root.querySelectorAll) return;
    var hiddenImageNeedles = [
      "lucmint-clean-original-burmese-ruby-sterling-silver-ring-04_c08df8a2-3aee-4d84-a85f-2441673a53fa.jpg",
      "lucmint-diopside-sterling-silver-adjustable-ring-designkit-05.jpg"
    ];
    root.querySelectorAll("img").forEach(function(image){
      var source = image.currentSrc || image.src || image.getAttribute("src") || "";
      var shouldHide = hiddenImageNeedles.some(function(needle){
        return source.indexOf(needle) !== -1;
      });
      if (!shouldHide) return;
      var paragraph = image.closest(".ao-accordion-content p, .rte p");
      var galleryItem = image.closest(".ao-gallery-slide, .ao-gallery-thumb");
      var target = paragraph || galleryItem || image;
      target.remove();
    });
  }

  removeKnownBlankProductImages(document);
  document.addEventListener("DOMContentLoaded", function(){ removeKnownBlankProductImages(document); });
  if (window.MutationObserver && document.body) {
    new MutationObserver(function(mutations){
      mutations.forEach(function(mutation){
        mutation.addedNodes.forEach(function(node){
          if (node.nodeType === 1) removeKnownBlankProductImages(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  function parseMinorUnits(value){
    var amount = Number(value);
    return isFinite(amount) && amount >= 0 ? amount : 0;
  }

  function moneyCurrency(value){
    return value || document.documentElement.getAttribute("data-qsd-currency") || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "SGD";
  }

  function formatMoney(value){
    if (window.QSDMoney) return window.QSDMoney.product(value);
    return moneyCurrency() + " " + Math.round(Number(value || 0) / 100).toLocaleString(document.documentElement.lang || "en");
  }

  function updateProductPrices(form, option){
    var info = form && form.closest(".ao-product-info");
    if (!info || !option) return;
    var quantityInput = form.querySelector("[name='quantity']");
    var quantity = Math.max(1, Number(quantityInput && quantityInput.value || 1));
    var sale = info.querySelector("[data-product-sale]");
    var compare = info.querySelector("[data-product-compare]");
    var save = info.querySelector("[data-product-save]");
    var hasCompare = option.getAttribute("data-has-compare") === "true";
    var hasSavings = option.getAttribute("data-has-savings") === "true";
    var saleTotal = parseMinorUnits(option.getAttribute("data-price")) * quantity;
    var compareTotal = parseMinorUnits(option.getAttribute("data-compare")) * quantity;
    var saveTotal = parseMinorUnits(option.getAttribute("data-save")) * quantity;
    if (sale) sale.textContent = formatMoney(saleTotal);
    if (compare) {
      compare.textContent = formatMoney(compareTotal);
      compare.hidden = !hasCompare;
    }
    if (save) {
      save.textContent = "SAVE " + formatMoney(saveTotal);
      save.hidden = !hasSavings;
    }
    var priceNotes = info.querySelector("[data-product-price-notes]");
    if (priceNotes) {
      var originalNote = priceNotes.querySelector("[data-price-original-note]");
      var originalValue = priceNotes.querySelector("[data-price-original-value]");
      var shippingNote = priceNotes.querySelector("[data-price-free-shipping-note]");
      var originalAmount = parseMinorUnits(option.getAttribute("data-original-note-price"));
      var freeShipping = option.getAttribute("data-free-shipping-note") === "true";
      if (originalNote) originalNote.hidden = originalAmount <= 0;
      if (originalValue && originalAmount > 0) originalValue.textContent = formatMoney(originalAmount * quantity);
      if (shippingNote) shippingNote.hidden = !freeShipping;
      priceNotes.hidden = originalAmount <= 0 && !freeShipping;
    }
  }

  document.addEventListener("click", function(event){
    var stepper = event.target.closest("[data-qty-step]");
    if (!stepper) return;
    var wrap = stepper.closest("[data-quantity-control]");
    var input = wrap && wrap.querySelector("input");
    if (!input) return;
    var next = Math.max(1, Number(input.value || 1) + Number(stepper.getAttribute("data-qty-step")));
    input.value = next;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  function initProductGallery(gallery){
    if (!gallery || gallery._aoGalleryReady) return;
    gallery._aoGalleryReady = true;
    var track = gallery.querySelector("[data-gallery-track]");
    var slides = Array.from(gallery.querySelectorAll("[data-gallery-slide]"));
    var thumbs = Array.from(gallery.querySelectorAll("[data-gallery-thumb]"));
    var dots = Array.from(gallery.querySelectorAll("[data-gallery-dot]"));
    var previous = gallery.querySelector("[data-gallery-prev]");
    var next = gallery.querySelector("[data-gallery-next]");
    var windowEl = gallery.querySelector(".ao-gallery-window");
    var activeIndex = 0;
    if (!track || !slides.length) return;

    function loadActiveGalleryVideo(slide, userRequested){
      if (!slide) return;
      var video = slide.querySelector("[data-gallery-video]");
      if (!video) return;
      var poster = video.getAttribute("data-poster");
      if (poster && !video.getAttribute("poster")) {
        video.setAttribute("poster", poster);
        video.removeAttribute("data-poster");
      }
      if (video.hasAttribute("data-gallery-click-only") && !userRequested) return;
      var source = video.querySelector("source[data-src]");
      if (source) {
        var src = source.getAttribute("data-src");
        var needsLoad = false;
        if (src && !source.getAttribute("src")) {
          source.setAttribute("src", src);
          needsLoad = true;
        }
        if (source.getAttribute("src") && (needsLoad || video.error)) {
          video.preload = "metadata";
          if (typeof video.load === "function") video.load();
        }
      }
    }

    function pauseInactiveGalleryVideos(activeSlide){
      slides.forEach(function(slide){
        if (slide === activeSlide) return;
        var video = slide.querySelector("[data-gallery-video]");
        if (video && typeof video.pause === "function") video.pause();
      });
    }

    slides.forEach(function(slide){
      var video = slide.querySelector("[data-gallery-video]");
      var button = slide.querySelector("[data-gallery-play]");
      if (!video || !button) return;
      function showPlayButton(){
        button.hidden = false;
        button.disabled = false;
      }
      video.addEventListener("play", function(){
        if (slide !== slides[activeIndex] || document.hidden) {
          video.pause();
          showPlayButton();
          return;
        }
        button.hidden = true;
        button.disabled = false;
      });
      video.addEventListener("pause", showPlayButton);
      video.addEventListener("ended", showPlayButton);
      video.addEventListener("error", showPlayButton);
      button.addEventListener("click", function(event){
        event.preventDefault();
        event.stopPropagation();
        if (slide !== slides[activeIndex] || document.hidden) return;
        button.disabled = true;
        try {
          loadActiveGalleryVideo(slide, true);
          video.muted = false;
          if (video.volume === 0) video.volume = 1;
          var playback = video.play();
          if (playback && typeof playback.catch === "function") playback.catch(showPlayButton);
        } catch (error) { showPlayButton(); }
      });
    });
    document.addEventListener("visibilitychange", function(){
      if (document.hidden && gallery.isConnected) pauseInactiveGalleryVideos(null);
    });

    function setActive(index){
      var nextIndex = (index + slides.length) % slides.length;
      var activeSlide = slides[nextIndex];
      pauseInactiveGalleryVideos(activeSlide);
      activeIndex = nextIndex;
      track.style.transform = "translateX(" + (-100 * activeIndex) + "%)";
      thumbs.forEach(function(button){
        var isActive = Number(button.getAttribute("data-gallery-thumb")) === activeIndex;
        button.classList.toggle("is-active", isActive);
        button.setAttribute("aria-current", isActive ? "true" : "false");
      });
      dots.forEach(function(button){
        button.classList.toggle("is-active", Number(button.getAttribute("data-gallery-dot")) === activeIndex);
      });
      loadActiveGalleryVideo(activeSlide);
    }

    thumbs.forEach(function(button){
      button.addEventListener("click", function(){
        setActive(Number(button.getAttribute("data-gallery-thumb")) || 0);
      });
    });
    dots.forEach(function(button){
      button.addEventListener("click", function(){
        setActive(Number(button.getAttribute("data-gallery-dot")) || 0);
      });
    });
    if (previous) previous.addEventListener("click", function(){ setActive(activeIndex - 1); });
    if (next) next.addEventListener("click", function(){ setActive(activeIndex + 1); });

    if (windowEl && slides.length > 1) {
      var startX = 0;
      var startY = 0;
      var currentX = 0;
      var dragging = false;
      var horizontal = false;
      function finishDrag(){
        if (!dragging) return;
        var dx = currentX - startX;
        var threshold = Math.max(42, windowEl.getBoundingClientRect().width * 0.14);
        dragging = false;
        horizontal = false;
        track.classList.remove("is-dragging");
        if (Math.abs(dx) > threshold) setActive(activeIndex + (dx < 0 ? 1 : -1));
        else setActive(activeIndex);
      }
      windowEl.addEventListener("pointerdown", function(event){
        /* HymnArt product gallery arrow click fix: keep the swipe handler from capturing arrow, thumbnail, or dot clicks. */
        if (event.target.closest && event.target.closest("[data-gallery-prev], [data-gallery-next], [data-gallery-thumb], [data-gallery-dot], video, [data-gallery-play]")) return;
        if (event.pointerType === "mouse" && event.button !== 0) return;
        dragging = true;
        horizontal = false;
        startX = event.clientX;
        currentX = event.clientX;
        startY = event.clientY;
        track.classList.add("is-dragging");
        if (windowEl.setPointerCapture) windowEl.setPointerCapture(event.pointerId);
      });
      windowEl.addEventListener("pointermove", function(event){
        if (!dragging) return;
        var dx = event.clientX - startX;
        var dy = event.clientY - startY;
        if (!horizontal && Math.abs(dx) > 8) horizontal = Math.abs(dx) > Math.abs(dy);
        if (!horizontal) return;
        event.preventDefault();
        currentX = event.clientX;
        var percent = (dx / (windowEl.getBoundingClientRect().width || 1)) * 100;
        track.style.transform = "translateX(calc(" + (-100 * activeIndex) + "% + " + percent + "%))";
      }, { passive: false });
      windowEl.addEventListener("pointerup", finishDrag);
      windowEl.addEventListener("pointercancel", finishDrag);
      windowEl.addEventListener("lostpointercapture", finishDrag);
    }

    setActive(0);
  }




  /* QSD instruction image runtime sync start */
  function ensureQsdInstructionImage(){
    if (window.location.pathname.indexOf('/products/qiang-shen-dan-official') === -1) return null;
    var imageUrl = "https://cdn.shopify.com/s/files/1/0801/9522/3776/t/13/assets/qsd-product-instructions-qiangshendan.jpg?v=1786665373";
    function instructionSrcset(widths) {
      return widths.map(function(width) { return imageUrl + '&width=' + width + ' ' + width + 'w'; }).join(', ');
    }
    var imageNeedle = 'qsd-product-instructions-qiangshendan';
    var imageAlt = qsdText("强肾丹产品说明书");
    var gallery = document.querySelector('[data-product-gallery]');
    var galleryChanged = false;
    if (gallery && !gallery.querySelector('img[src*="' + imageNeedle + '"]')) {
      var track = gallery.querySelector('[data-gallery-track]');
      var thumbs = gallery.querySelector('.ao-gallery-thumbs');
      var dots = gallery.querySelector('.ao-gallery-dots');
      var index = track ? track.querySelectorAll('[data-gallery-slide]').length : 0;
      if (track) {
        var slide = document.createElement('div');
        slide.className = 'ao-gallery-slide';
        slide.setAttribute('data-gallery-slide', '');
        slide.setAttribute('data-media-type', 'image');
        slide.innerHTML = '<img src="' + imageUrl + '&width=1000" srcset="' + instructionSrcset([480,640,800,1000,1400,2048]) + '" sizes="(max-width:1100px) calc(100vw - 36px), 58vw" alt="' + imageAlt + '" loading="lazy" decoding="async" width="1200" height="1200">';
        track.appendChild(slide);
        galleryChanged = true;
      }
      if (thumbs) {
        var thumb = document.createElement('button');
        thumb.className = 'ao-gallery-thumb';
        thumb.type = 'button';
        thumb.setAttribute('data-gallery-thumb', String(index));
        thumb.setAttribute('aria-label', 'Show media ' + (index + 1));
        thumb.innerHTML = '<img src="' + imageUrl + '&width=112" srcset="' + instructionSrcset([112,224]) + '" sizes="54px" alt="' + imageAlt + '" loading="lazy" decoding="async" width="112" height="112">';
        thumbs.appendChild(thumb);
      }
      if (dots) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('data-gallery-dot', String(index));
        dot.setAttribute('aria-label', 'Show media ' + (index + 1));
        dots.appendChild(dot);
      }
    }
    var detailGallery = document.querySelector('.za-qsd-ai-detail-gallery');
    if (detailGallery && !detailGallery.querySelector('img[src*="' + imageNeedle + '"]')) {
      var figure = document.createElement('figure');
      figure.className = 'za-qsd-ai-detail-gallery__item';
      figure.innerHTML = '<img src="' + imageUrl + '&width=1000" srcset="' + instructionSrcset([480,640,800,1000,1400,2048]) + '" sizes="(max-width:1100px) calc(100vw - 36px), 58vw" alt="' + imageAlt + '" loading="lazy" decoding="async" width="1200" height="1200">';
      detailGallery.appendChild(figure);
    }
    return { gallery: gallery, galleryChanged: galleryChanged };
  }

  function refreshQsdInstructionImage(){
    var result = ensureQsdInstructionImage();
    if (!result || !result.gallery) return;
    var gallery = result.gallery;
    if (result.galleryChanged && gallery._aoGalleryReady) {
      var replacement = gallery.cloneNode(true);
      gallery.parentNode.replaceChild(replacement, gallery);
      gallery = replacement;
    }
    if (!gallery._aoGalleryReady) initProductGallery(gallery);
  }

  refreshQsdInstructionImage();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshQsdInstructionImage, { once: true });
  }
  document.addEventListener('shopify:section:load', refreshQsdInstructionImage);
  window.setTimeout(refreshQsdInstructionImage, 250);
  window.setTimeout(refreshQsdInstructionImage, 1200);
  /* QSD instruction image runtime sync end */

  document.querySelectorAll("[data-product-gallery]").forEach(initProductGallery);


  function updateMayLikeButtons(carousel){
    var rail = carousel.querySelector("[data-may-like-rail]");
    var previous = carousel.querySelector("[data-may-like-prev]");
    var next = carousel.querySelector("[data-may-like-next]");
    if (!rail || !previous || !next) return;
    var maxScroll = rail.scrollWidth - rail.clientWidth;
    previous.disabled = rail.scrollLeft <= 24;
    next.disabled = rail.scrollLeft >= maxScroll - 24;
  }

  document.addEventListener("click", function(event){
    var button = event.target.closest("[data-may-like-prev], [data-may-like-next]");
    if (!button) return;
    var carousel = button.closest("[data-may-like-carousel]");
    var rail = carousel && carousel.querySelector("[data-may-like-rail]");
    if (!rail) return;
    var direction = button.matches("[data-may-like-prev]") ? -1 : 1;
    rail.scrollBy({ left: direction * Math.max(rail.clientWidth - 20, 260), behavior: "smooth" });
    window.setTimeout(function(){ updateMayLikeButtons(carousel); }, 350);
  });

  document.querySelectorAll("[data-may-like-carousel]").forEach(function(carousel){
    var rail = carousel.querySelector("[data-may-like-rail]");
    if (!rail) return;
    if (rail.hasAttribute("data-randomize-rail")) {
      Array.from(rail.children)
        .sort(function(){ return Math.random() - 0.5; })
        .forEach(function(card){ rail.appendChild(card); });
    }
    rail.addEventListener("scroll", function(){ updateMayLikeButtons(carousel); }, { passive: true });
    window.addEventListener("resize", function(){ updateMayLikeButtons(carousel); });
    updateMayLikeButtons(carousel);
  });

  document.addEventListener("click", function(event){
    var button = event.target.closest("[data-action-prev], [data-action-next]");
    if (!button) return;
    var gallery = button.closest("[data-action-gallery]");
    var rail = gallery && gallery.querySelector("[data-action-rail]");
    if (!rail) return;
    var direction = button.matches("[data-action-prev]") ? -1 : 1;
    rail.scrollBy({ left: direction * 128, behavior: "smooth" });
  });

  function getActionItems(gallery){
    return Array.from(gallery.querySelectorAll("[data-action-video]"));
  }

  function openActionVideo(gallery, index){
    var modal = gallery.querySelector("[data-action-modal]");
    var video = gallery.querySelector("[data-action-video-player]");
    var source = video && video.querySelector("source");
    var items = getActionItems(gallery);
    var item = items[index];
    if (!modal || !video || !source || !item) return;
    var src = item.getAttribute("data-action-video");
    if (!src) return;
    var poster = item.getAttribute("data-action-poster") || "";
    if (poster) video.setAttribute("poster", poster);
    else video.removeAttribute("poster");
    video.preload = "metadata";
    gallery.setAttribute("data-action-active", String(index));
    if (source.getAttribute("src") !== src) {
      source.setAttribute("src", src);
      video.load();
    }
    modal.hidden = false;
    document.body.classList.add("ao-action-modal-open");
    video.play().catch(function(){});
    var previous = gallery.querySelector("[data-action-modal-prev]");
    var next = gallery.querySelector("[data-action-modal-next]");
    if (previous) previous.disabled = index <= 0;
    if (next) next.disabled = index >= items.length - 1;
  }

  function closeActionVideo(gallery){
    var modal = gallery.querySelector("[data-action-modal]");
    var video = gallery.querySelector("[data-action-video-player]");
    if (video) {
      video.pause();
      var source = video.querySelector("source");
      if (source) source.removeAttribute("src");
      video.removeAttribute("poster");
      if (typeof video.load === "function") video.load();
    }
    if (modal) modal.hidden = true;
    document.body.classList.remove("ao-action-modal-open");
  }

  document.addEventListener("click", function(event){
    var item = event.target.closest("[data-action-video]");
    if (item) {
      var gallery = item.closest("[data-action-gallery]");
      var items = gallery ? getActionItems(gallery) : [];
      openActionVideo(gallery, items.indexOf(item));
      return;
    }

    var close = event.target.closest("[data-action-close]");
    if (close) {
      closeActionVideo(close.closest("[data-action-gallery]"));
      return;
    }

    var modal = event.target.closest("[data-action-modal]");
    if (modal && event.target === modal) {
      closeActionVideo(modal.closest("[data-action-gallery]"));
      return;
    }

    var nav = event.target.closest("[data-action-modal-prev], [data-action-modal-next]");
    if (!nav) return;
    var gallery = nav.closest("[data-action-gallery]");
    var active = Number(gallery.getAttribute("data-action-active") || 0);
    openActionVideo(gallery, active + (nav.matches("[data-action-modal-prev]") ? -1 : 1));
  });

  document.addEventListener("keydown", function(event){
    if (event.key !== "Escape") return;
    document.querySelectorAll("[data-action-modal]:not([hidden])").forEach(function(modal){
      closeActionVideo(modal.closest("[data-action-gallery]"));
    });
  });

  function attachReviewHls(video, hlsUrl, fallbackUrl){
    var fallback = function(){
      if (!video) return;
      var source = video.querySelector("[data-loox-modal-source]");
      if (source) {
        video.removeAttribute("src");
        source.setAttribute("src", fallbackUrl);
        source.setAttribute("type", "video/mp4");
      } else {
        video.src = fallbackUrl;
      }
      if (typeof video.load === "function") video.load();
    };
    if (video && typeof video.canPlayType === "function" && video.canPlayType("application/vnd.apple.mpegurl")) {
      video.src = hlsUrl;
      if (typeof video.load === "function") video.load();
      return;
    }
    var attach = function(HlsCtor){
      if (!video || !HlsCtor || !HlsCtor.isSupported()) { fallback(); return; }
      if (video._zionReviewHls) video._zionReviewHls.destroy();
      var hls = new HlsCtor({ enableWorker: true, capLevelToPlayerSize: true });
      video._zionReviewHls = hls;
      hls.on(HlsCtor.Events.ERROR, function(_event, data){
        if (data && data.fatal && video.readyState === 0) {
          hls.destroy();
          video._zionReviewHls = null;
          fallback();
        }
      });
      hls.loadSource(hlsUrl);
      hls.attachMedia(video);
    };
    if (window.Hls) { attach(window.Hls); return; }
    if (!window.__zionHlsPromise) {
      window.__zionHlsPromise = new Promise(function(resolve, reject){
        var script = document.createElement("script");
        var atelierScript = document.querySelector('script[src*="/assets/atelier.js"]');
        script.src = atelierScript ? atelierScript.src.replace(/\/atelier\.js(?:\?.*)?$/i, "/hls.min.js") : "https://cdn.jsdelivr.net/npm/hls.js@1.5.17/dist/hls.min.js";
        script.async = true;
        script.onload = function(){ resolve(window.Hls); };
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }
    window.__zionHlsPromise.then(attach).catch(fallback);
  }

  function closeLooxModal(modal){
    if (!modal) return;
    var image = modal.querySelector("[data-loox-modal-image]");
    var video = modal.querySelector("[data-loox-modal-video]");
    var source = video && video.querySelector("[data-loox-modal-source]");
    var frame = modal.querySelector("[data-loox-modal-frame]");
    modal.hidden = true;
    if (image) {
      image.hidden = true;
      image.removeAttribute("src");
    }
    if (video) {
      if (video._zionReviewHls) {
        video._zionReviewHls.destroy();
        video._zionReviewHls = null;
      }
      if (typeof video.pause === "function") video.pause();
      video.hidden = true;
      video.removeAttribute("src");
      video.removeAttribute("poster");
      if (source) {
        source.removeAttribute("src");
        source.setAttribute("type", "video/mp4");
      }
      if (typeof video.load === "function") video.load();
      if ("currentTime" in video) {
        try { video.currentTime = 0; } catch (error) {}
      }
    }
    if (frame) {
      frame.hidden = true;
      frame.removeAttribute("src");
    }
    document.body.classList.remove("ao-loox-modal-open");
  }

  document.addEventListener("click", function(event){
    var media = event.target.closest("[data-loox-media]");
    if (media) {
      var widget = media.closest(".ao-loox-static, .zion-reviews");
      var modal = widget && widget.querySelector("[data-loox-modal]");
      if (!modal) modal = document.querySelector("[data-loox-modal]");
      var image = modal && modal.querySelector("[data-loox-modal-image]");
      var video = modal && modal.querySelector("[data-loox-modal-video]");
      var source = video && video.querySelector("[data-loox-modal-source]");
      var frame = modal && modal.querySelector("[data-loox-modal-frame]");
      var details = modal && modal.querySelector("[data-loox-modal-details]");
      if (!modal || !image || (!video && !frame)) return;

      var kind = media.getAttribute("data-loox-kind");
      var videoUrl = media.getAttribute("data-loox-video") || "";
      var hlsVideoUrl = media.getAttribute("data-loox-video-hls") || "";
      var shopifyVideoUrl = media.getAttribute("data-loox-shopify-video") || "";
      var shopifyVideoType = media.getAttribute("data-loox-shopify-video-type") || "video/mp4";
      var shopifyVideoPoster = media.getAttribute("data-loox-shopify-poster") || "";
      var imageUrl = media.getAttribute("data-loox-src") || "";
      image.hidden = true;
      if (video) video.hidden = true;
      if (frame) frame.hidden = true;
      image.removeAttribute("src");
      if (video) {
        if (video._zionReviewHls) {
          video._zionReviewHls.destroy();
          video._zionReviewHls = null;
        }
        video.removeAttribute("src");
        video.removeAttribute("poster");
        if (source) {
          source.removeAttribute("src");
          source.setAttribute("type", "video/mp4");
        }
      }
      if (frame) frame.removeAttribute("src");

      if (kind === "video" && (shopifyVideoUrl || videoUrl)) {
        if (shopifyVideoUrl) {
          if (!video) return;
          var nativePoster = shopifyVideoPoster || imageUrl;
          if (nativePoster) video.setAttribute("poster", nativePoster);
          video.controls = true;
          video.playsInline = true;
          video.preload = "metadata";
          video.setAttribute("controlslist", "nodownload noplaybackrate");
          if ("disablePictureInPicture" in video) video.disablePictureInPicture = true;
          video.hidden = false;
          if (source) {
            video.removeAttribute("src");
            source.setAttribute("src", shopifyVideoUrl);
            source.setAttribute("type", shopifyVideoType);
          } else {
            video.setAttribute("src", shopifyVideoUrl);
          }
          if (typeof video.load === "function") video.load();
        } else {
          var normalizedVideoUrl = videoUrl.replace(/^\/\//, window.location.protocol + "//");
          var fallbackVideoUrl = normalizedVideoUrl;
          var isAppleMobile = /iPad|iPhone|iPod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
          var isMobileDevice = isAppleMobile || /Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
          var streamHlsUrl = hlsVideoUrl || fallbackVideoUrl.replace(/\/downloads\/default\.mp4(?:[?#].*)?$/i, "/manifest/video.m3u8");
          var hasStreamHls = /\.m3u8(?:[?#].*)?$/i.test(streamHlsUrl);
          var isNativeHls = isAppleMobile && hasStreamHls;
          if (isNativeHls) normalizedVideoUrl = streamHlsUrl;
          if (/\.(mp4|webm|mov)(\?|#|$)/i.test(normalizedVideoUrl) || isNativeHls) {
          if (!video) return;
          if (imageUrl) video.setAttribute("poster", imageUrl);
          video.controls = true;
          video.playsInline = true;
          video.preload = "metadata";
          video.setAttribute("controlslist", "nodownload noplaybackrate");
          video.hidden = false;
          if (hasStreamHls) {
            attachReviewHls(video, streamHlsUrl, fallbackVideoUrl);
          } else {
            if (source) {
              video.removeAttribute("src");
              source.setAttribute("src", normalizedVideoUrl);
              source.setAttribute("type", /\.webm(\?|#|$)/i.test(normalizedVideoUrl) ? "video/webm" : "video/mp4");
            } else {
              video.setAttribute("src", normalizedVideoUrl);
            }
            if (typeof video.load === "function") video.load();
          }
        } else {
          if (!frame) return;
          frame.setAttribute("src", normalizedVideoUrl);
          frame.setAttribute("allow", "autoplay; fullscreen; picture-in-picture");
          frame.hidden = false;
        }
        }
      } else {
        image.src = imageUrl;
        image.alt = media.getAttribute("data-loox-alt") || "";
        image.hidden = false;
      }

      var cardBody = media.closest(".ao-loox-card") && media.closest(".ao-loox-card").querySelector(".ao-loox-card-body");
      if (details && cardBody) details.innerHTML = cardBody.innerHTML;
      modal.hidden = false;
      document.body.classList.add("ao-loox-modal-open");
      var dialog = modal.querySelector(".ao-loox-modal__dialog");
      if (dialog) dialog.focus();
      return;
    }

    var close = event.target.closest("[data-loox-modal-close]");
    if (close) closeLooxModal(close.closest("[data-loox-modal]"));
  });

  document.addEventListener("keydown", function(event){
    if (event.key !== "Escape") return;
    document.querySelectorAll("[data-loox-modal]:not([hidden])").forEach(closeLooxModal);
  });

  document.querySelectorAll(".ao-accordion").forEach(function(accordion){
    var toggle = accordion.querySelector(".ao-accordion-toggle");
    if (toggle) toggle.setAttribute("aria-expanded", accordion.open ? "true" : "false");
  });

  document.addEventListener("click", function(event){
    var summary = event.target.closest(".ao-accordion > summary");
    if (!summary) return;
    event.preventDefault();
    var toggle = event.target.closest(".ao-accordion-toggle");
    if (!toggle) return;
    var accordion = summary.parentElement;
    accordion.open = !accordion.open;
    toggle.setAttribute("aria-expanded", accordion.open ? "true" : "false");
  });

  document.addEventListener("keydown", function(event){
    if (event.key !== "Enter" && event.key !== " ") return;
    var toggle = event.target.closest(".ao-accordion-toggle");
    if (!toggle) return;
    event.preventDefault();
    var accordion = toggle.closest(".ao-accordion");
    accordion.open = !accordion.open;
    toggle.setAttribute("aria-expanded", accordion.open ? "true" : "false");
  });

  function updateDisclosureLabel(input){
    var disclosure = input.closest("[data-option-disclosure]");
    var label = disclosure && disclosure.querySelector("summary strong");
    if (label) label.textContent = input.value;
  }

  var frameTooltipTimer;
  function showFrameTooltip(swatch, disclosure){
    document.querySelectorAll(".ao-frame-swatch.is-tooltip-active").forEach(function(active){
      active.classList.remove("is-tooltip-active");
    });
    swatch.classList.add("is-tooltip-active");
    window.clearTimeout(frameTooltipTimer);
    frameTooltipTimer = window.setTimeout(function(){
      swatch.classList.remove("is-tooltip-active");
      if (disclosure && !disclosure.hasAttribute("data-always-open")) disclosure.open = false;
    }, 1400);
  }

  document.querySelectorAll("[data-option-disclosure][data-always-open]").forEach(function(disclosure){
    disclosure.open = true;
    disclosure.addEventListener("toggle", function(){
      if (!disclosure.open) disclosure.open = true;
    });
  });

  document.addEventListener("click", function(event){
    var frameSwatch = event.target.closest(".ao-frame-swatch");
    if (frameSwatch) {
      showFrameTooltip(frameSwatch, frameSwatch.closest("[data-option-disclosure]"));
    }

    var summary = event.target.closest("[data-option-disclosure] > summary");
    if (!summary) return;
    var disclosure = summary.parentElement;
    if (!disclosure) return;
    event.preventDefault();
    if (disclosure.hasAttribute("data-always-open")) {
      disclosure.open = true;
      return;
    }
    disclosure.open = !disclosure.open;
  });

  function syncVariantGallery(form, variantOption){
    var shell = form.closest(".ao-product-shell");
    var gallery = shell && shell.querySelector("[data-product-gallery][data-qsd-gallery-version]");
    var mediaId = variantOption && variantOption.getAttribute("data-media-id");
    if (!gallery || !mediaId) return;
    var slides = Array.from(gallery.querySelectorAll("[data-gallery-slide]"));
    var index = slides.findIndex(function(slide){
      return slide.getAttribute("data-media-id") === mediaId;
    });
    if (index < 0) return;
    var control = gallery.querySelector('[data-gallery-thumb="' + index + '"]') ||
      gallery.querySelector('[data-gallery-dot="' + index + '"]');
    if (control) control.click();
  }

  function syncProductForm(form, preserveGallery){
    var select = form.querySelector("[data-variant-select]");
    if (!select) return;
    var selectedInputs = Array.from(form.querySelectorAll("[data-option-input]:checked"));
    var selected = selectedInputs.map(function(input){ return input.value; });
    var selectedSize = (form.querySelector("[data-option-kind='size']:checked") || {}).value;
    var selectedFrame = (form.querySelector("[data-option-kind='frame']:checked") || {}).value;
    var sizeLabel = form.querySelector("[data-selected-size-label]");
    var frameLabel = form.querySelector("[data-selected-frame-label]");
    if (sizeLabel && selectedSize) sizeLabel.textContent = selectedSize;
    if (frameLabel && selectedFrame) frameLabel.textContent = selectedFrame;
    var match = Array.from(select.options).find(function(option){
      if (selectedSize || selectedFrame) {
        return option.getAttribute("data-size") === (selectedSize || "") && option.getAttribute("data-frame") === (selectedFrame || "");
      }
      try {
        var values = JSON.parse(option.getAttribute("data-options") || "[]");
        return values.length === selected.length && values.every(function(value, index){ return value === selected[index]; });
      } catch(e) {
        return false;
      }
    });
    if (!match) return;
    select.value = match.value;
    var submit = form.querySelector("[data-product-submit]");
    if (submit) {
      submit.disabled = match.disabled;
      submit.textContent = match.disabled ? "SOLD OUT" : "ADD TO CART";
    }
    updateProductPrices(form, match);
    if (!preserveGallery) syncVariantGallery(form, match);
  }

  function initProductForm(form){
    if (!form || form._aoProductFormReady) return;
    form._aoProductFormReady = true;
    form.addEventListener("click", function(event){
      if (!event.target.matches("[data-option-input]:checked")) return;
      var shell = form.closest(".ao-product-shell");
      if (shell && shell.querySelector("[data-product-gallery][data-qsd-gallery-version]")) {
        syncProductForm(form);
      }
    });
    var fallback = form.querySelector("[data-payment-fallback]");
    if (fallback) fallback.hidden = false;
    form.addEventListener("submit", function(event){
      var submitter = event.submitter || document.activeElement;
      if (!submitter || !submitter.matches || !submitter.matches("[data-product-submit]")) return;
      submitter.classList.add("is-loading");
      submitter.setAttribute("aria-busy", "true");
      submitter.disabled = true;
      submitter.textContent = "ADDING...";
    });
    form.addEventListener("change", function(event){
      if (event.target.matches("[data-option-input]")) {
        updateDisclosureLabel(event.target);
        syncProductForm(form);
        var disclosure = event.target.closest("[data-option-disclosure]");
        if (event.target.matches("[data-option-kind='frame']")) {
          var swatch = form.querySelector("label[for='" + event.target.id + "']");
          if (swatch) showFrameTooltip(swatch, disclosure);
        } else if (disclosure) {
          disclosure.open = false;
        }
        
      }
      if (event.target.matches("[name='quantity']")) {
        var quantity = Math.max(1, Number(event.target.value || 1));
        event.target.value = quantity;
        var select = form.querySelector("[data-variant-select]");
        if (select) updateProductPrices(form, select.selectedOptions[0]);
        
      }
    });
    form.querySelectorAll("[data-option-input]:checked").forEach(updateDisclosureLabel);
    syncProductForm(form, true);
  }

  document.querySelectorAll(".ao-product-form").forEach(initProductForm);

  function resetProductSubmitButtons(){
    document.querySelectorAll(".ao-product-form").forEach(function(form){
      var submit = form.querySelector("[data-product-submit]");
      if (!submit) return;
      submit.classList.remove("is-loading");
      submit.removeAttribute("aria-busy");
      submit.disabled = false;
      syncProductForm(form, true);
    });
  }

  window.addEventListener("pageshow", resetProductSubmitButtons);
  document.addEventListener("visibilitychange", function(){
    if (document.visibilityState === "visible") resetProductSubmitButtons();
  });


  function quickFormatMoney(cents, currency){
    if (window.QSDMoney) return window.QSDMoney.actual(cents, currency);
    return moneyCurrency(currency) + " " + (Number(cents || 0) / 100).toLocaleString(document.documentElement.lang || "en", { minimumFractionDigits: Number(cents || 0) % 100 === 0 ? 0 : 2, maximumFractionDigits: 2 });
  }

  function postCartJson(url, payload){
    return fetch(qsdHref(url), {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(payload)
    }).then(function(response){
      return response.json().catch(function(){ return {}; }).then(function(data){
        if (!response.ok) throw new Error(data.description || "Cart update failed");
        return data;
      });
    });
  }


  function setCartUpdating(target, updating){
    if (!target) return;
    target.classList.toggle("is-updating", updating);
  }

  function syncCartCount(cart){
    var dots = Array.from(document.querySelectorAll(".ao-cart-dot"));
    if (cart.item_count > 0 && !dots.length) {
      document.querySelectorAll(".ao-header-actions a[href$='/cart']").forEach(function(link){
        var dot = document.createElement("span");
        dot.className = "ao-cart-dot";
        dot.setAttribute("aria-hidden", "true");
        link.appendChild(dot);
      });
      dots = Array.from(document.querySelectorAll(".ao-cart-dot"));
    }
    dots.forEach(function(dot){
      if (cart.item_count > 0) dot.textContent = cart.item_count;
      else dot.remove();
    });
  }

  function reindexCartLines(form){
    form.querySelectorAll("[data-cart-line]").forEach(function(lineEl, index){
      var line = index + 1;
      lineEl.setAttribute("data-line", line);
      var input = lineEl.querySelector("[data-cart-quantity-input]");
      if (input) input.setAttribute("data-line", line);
      var remove = lineEl.querySelector("[data-cart-remove]");
      if (remove) remove.setAttribute("href", qsdHref("/cart/change?line=" + line + "&quantity=0"));
    });
  }

  function cartPropertiesMatch(left, right){
    left = left || {};
    right = right || {};
    var leftKeys = Object.keys(left).filter(function(key){ return left[key] != null && left[key] !== ""; }).sort();
    var rightKeys = Object.keys(right).filter(function(key){ return right[key] != null && right[key] !== ""; }).sort();
    if (leftKeys.length !== rightKeys.length) return false;
    return leftKeys.every(function(key, index){
      return key === rightKeys[index] && String(left[key]) === String(right[key]);
    });
  }

  function findCartItemForLine(cart, lineEl){
    var key = lineEl.getAttribute("data-key");
    var items = cart.items || [];
    var item = items.find(function(cartItem){ return cartItem.key === key; });
    if (item) return item;

    var variantId = Number(lineEl.getAttribute("data-variant-id") || 0);
    var sellingPlanId = String(lineEl.getAttribute("data-selling-plan-id") || "");
    var properties = readCartLineJson(lineEl, "[data-cart-line-properties]", {});
    var candidates = items.filter(function(cartItem){
      var cartSellingPlanId = String(cartItem.selling_plan_allocation && cartItem.selling_plan_allocation.selling_plan && cartItem.selling_plan_allocation.selling_plan.id || "");
      return Number(cartItem.variant_id || 0) === variantId && cartSellingPlanId === sellingPlanId;
    });
    if (candidates.length === 1) return candidates[0];
    return candidates.find(function(cartItem){
      return cartPropertiesMatch(properties, cartItem.properties || {});
    });
  }

  function renderCartUpdate(cart, lineEl, form, requestedQuantity){
    var item = findCartItemForLine(cart, lineEl);
    if (!item) {
      if (Number(requestedQuantity || 0) <= 0) {
        lineEl.remove();
      } else {
        setCartUpdating(lineEl, false);
        var fallbackInput = lineEl.querySelector("[data-cart-quantity-input]");
        if (fallbackInput) fallbackInput.value = lineEl._aoCartConfirmedQuantity || requestedQuantity || 1;
      }
    } else {
      lineEl.setAttribute("data-key", item.key);
      lineEl.setAttribute("data-unit-price", item.final_price || 0);
      lineEl.setAttribute("data-line-price", item.final_line_price || 0);
      lineEl._aoCartConfirmedQuantity = item.quantity;
      var input = lineEl.querySelector("[data-cart-quantity-input]");
      var price = lineEl.querySelector(".ao-cart-line__price");
      if (input) input.value = item.quantity;
      if (price) price.textContent = quickFormatMoney(item.final_line_price, cart.currency);
      setCartUpdating(lineEl, false);
    }

    syncCartCount(cart);
    if (cart.item_count === 0 && Number(requestedQuantity || 0) <= 0) {
      form.innerHTML = '<div class="qsd-cart__empty"><h2>Your cart is empty</h2><a class="qsd-cart__continue" href="' + qsdHref('/products/qiang-shen-dan-official') + '">VIEW PRODUCT</a></div>';
      return;
    }
    var total = form.querySelector(".ao-cart-total");
    if (total) {
      total.textContent = "Subtotal: " + quickFormatMoney(cart.total_price, cart.currency);
      total.setAttribute("data-total-price", cart.total_price || 0);
    }
    reindexCartLines(form);
  }

  function updateCartLine(lineEl, quantity, form, previousQuantity, options){
    if (!lineEl || lineEl.classList.contains("is-updating")) return Promise.resolve();
    options = options || {};
    var input = lineEl.querySelector("[data-cart-quantity-input]");
    if (lineEl._aoCartConfirmedQuantity == null) {
      lineEl._aoCartConfirmedQuantity = Math.max(1, Number(previousQuantity != null ? previousQuantity : input && input.value || 1));
    }
    var desiredQuantity = options.allowZero ? Math.max(0, Number(quantity || 0)) : Math.max(1, Number(quantity || 1));
    var lineNumber = Number(lineEl.getAttribute("data-line") || 0);
    var payload = lineNumber > 0 ? {
      line: lineNumber,
      quantity: desiredQuantity
    } : {
      id: lineEl.getAttribute("data-key"),
      quantity: desiredQuantity
    };
    if (input) input.value = desiredQuantity;
    setCartUpdating(lineEl, true);
    return postCartJson("/cart/change.js", payload).then(function(cart){
      renderCartUpdate(cart, lineEl, form, desiredQuantity);
    }).catch(function(){
      setCartUpdating(lineEl, false);
      if (input) {
        input.value = lineEl._aoCartConfirmedQuantity;
      }
    });
  }

  function readCartLineJson(lineEl, selector, fallback){
    var node = lineEl && lineEl.querySelector(selector);
    if (!node) return fallback;
    try {
      return JSON.parse(node.textContent || "");
    } catch (error) {
      return fallback;
    }
  }

  function resetCartVariantOptions(lineEl, variants){
    var currentId = Number(lineEl.getAttribute("data-variant-id") || 0);
    var current = variants.find(function(variant){ return Number(variant.id) === currentId; });
    if (!current) return;
    lineEl.querySelectorAll("[data-cart-variant-option]").forEach(function(select, index){
      select.value = current.options[index] || "";
    });
  }

  function normalizeCartProperties(properties){
    if (Array.isArray(properties)) {
      return properties.reduce(function(result, pair){
        if (Array.isArray(pair) && pair.length > 1) result[pair[0]] = pair[1];
        return result;
      }, {});
    }
    return properties && typeof properties === "object" ? properties : {};
  }

  function updateCartVariant(lineEl, form){
    var variants = readCartLineJson(lineEl, "[data-cart-variant-data]", []);
    var selected = Array.from(lineEl.querySelectorAll("[data-cart-variant-option]")).map(function(select){ return select.value; });
    var target = variants.find(function(variant){
      return variant.available !== false && variant.options.length === selected.length && variant.options.every(function(value, index){ return value === selected[index]; });
    });
    var message = lineEl.querySelector("[data-cart-variant-message]");

    if (!target) {
      resetCartVariantOptions(lineEl, variants);
      if (message) message.textContent = "This combination is unavailable.";
      return;
    }
    if (Number(target.id) === Number(lineEl.getAttribute("data-variant-id") || 0)) return;

    var quantityInput = lineEl.querySelector("[data-cart-quantity-input]");
    var payload = {
      id: Number(target.id),
      quantity: Math.max(1, Number(quantityInput && quantityInput.value || 1))
    };
    var properties = normalizeCartProperties(readCartLineJson(lineEl, "[data-cart-line-properties]", {}));
    if (properties && Object.keys(properties).length) payload.properties = properties;
    var sellingPlanId = Number(lineEl.getAttribute("data-selling-plan-id") || 0);
    if (sellingPlanId) payload.selling_plan = sellingPlanId;

    setCartUpdating(form, true);
    if (message) message.textContent = "Saving...";
    postCartJson("/cart/add.js", payload).then(function(item){
      if (!item.key) throw new Error("Cart line unavailable");
      return postCartJson("/cart/change.js", {
        id: lineEl.getAttribute("data-key"),
        quantity: 0
      });
    }).then(function(){
      window.location.reload();
    }).catch(function(){
      setCartUpdating(form, false);
      resetCartVariantOptions(lineEl, variants);
      if (message) message.textContent = "Could not save. Please try again.";
    });
  }

  document.addEventListener("click", function(event){
    var cartStep = event.target.closest("[data-cart-qty-step]");
    if (cartStep) {
      event.preventDefault();
      var lineEl = cartStep.closest("[data-cart-line]");
      var input = lineEl && lineEl.querySelector("[data-cart-quantity-input]");
      var form = cartStep.closest("form");
      if (!lineEl || !input || lineEl.classList.contains("is-updating")) return;
      var previous = Math.max(1, Number(input.value || 1));
      var step = Number(cartStep.getAttribute("data-cart-qty-step") || 0);
      if (step < 0 && previous <= 1) {
        input.value = 0;
        updateCartLine(lineEl, 0, form, previous, { allowZero: true });
        return;
      }
      var next = Math.max(1, previous + step);
      if (next === previous) {
        input.value = previous;
        return;
      }
      input.value = next;
      updateCartLine(lineEl, next, form, previous);
      return;
    }

    var cartRemove = event.target.closest("[data-cart-remove]");
    if (cartRemove) {
      event.preventDefault();
      var removeLine = cartRemove.closest("[data-cart-line]");
      if (removeLine) updateCartLine(removeLine, 0, cartRemove.closest("form"), undefined, { allowZero: true });
    }
  });

  document.addEventListener("change", function(event){
    if (event.target.matches("[data-cart-variant-option]")) {
      var variantLine = event.target.closest("[data-cart-line]");
      updateCartVariant(variantLine, event.target.closest("form"));
      return;
    }
    if (!event.target.matches("[data-cart-quantity-input]")) return;
    var input = event.target;
    var lineEl = input.closest("[data-cart-line]");
    input.value = Math.max(1, Number(input.value || 1));
    updateCartLine(lineEl, input.value, input.closest("form"));
  });
})();

/* HymnArt product card secondary images load only for desktop hover/focus */
(function () {
  if (!window.matchMedia || !window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;

  function loadSecondaryImage(card) {
    if (!card || !card.querySelector) return;
    var image = card.querySelector("img[data-ao-secondary-src]");
    if (!image || image.getAttribute("data-ao-secondary-loaded") === "true") return;

    image.setAttribute("data-ao-secondary-loaded", "true");
    var srcset = image.getAttribute("data-ao-secondary-srcset");
    var src = image.getAttribute("data-ao-secondary-src");
    if (srcset) image.setAttribute("srcset", srcset);
    if (src) image.setAttribute("src", src);
    image.addEventListener("load", function () {
      image.classList.add("is-loaded");
    }, { once: true });
  }

  document.addEventListener("pointerover", function (event) {
    var card = event.target && event.target.closest ? event.target.closest(".ao-product-card") : null;
    if (card) loadSecondaryImage(card);
  }, { passive: true });

  document.addEventListener("focusin", function (event) {
    var card = event.target && event.target.closest ? event.target.closest(".ao-product-card") : null;
    if (card) loadSecondaryImage(card);
  });
})();

/* HymnArt bounded image recovery */
(function () {
  if (window.__hymnartImageRetry) return;
  window.__hymnartImageRetry = true;

  function withRetryParam(url) {
    if (!url || /^(data:|blob:|mailto:|tel:|whatsapp:)/i.test(url)) return "";
    var clean = String(url)
      .replace(/([?&])hymnart_retry=[^&#\s]+&?/g, function (_match, prefix) {
        return prefix === "?" ? "?" : prefix;
      })
      .replace(/[?&]$/, "");
    var hashIndex = clean.indexOf("#");
    var hash = hashIndex >= 0 ? clean.slice(hashIndex) : "";
    var base = hashIndex >= 0 ? clean.slice(0, hashIndex) : clean;
    return base + (base.indexOf("?") >= 0 ? "&" : "?") + "hymnart_retry=1" + hash;
  }

  function retryOnce(img) {
    if (!img || img.tagName !== "IMG" || img.getAttribute("data-hymnart-no-retry") === "true") return;
    if (img.getAttribute("data-hymnart-retry-attempt") === "1") {
      img.setAttribute("data-hymnart-retry-failed", "true");
      return;
    }

    var source = img.currentSrc || img.getAttribute("src") || img.getAttribute("data-src") || "";
    var retrySource = withRetryParam(source);
    if (!retrySource) return;

    img.setAttribute("data-hymnart-retry-attempt", "1");
    img.setAttribute("decoding", "async");
    img.removeAttribute("srcset");

    var picture = img.closest && img.closest("picture");
    if (picture) {
      picture.querySelectorAll("source[srcset]").forEach(function (sourceNode) {
        sourceNode.removeAttribute("srcset");
      });
    }

    window.setTimeout(function () {
      img.src = retrySource;
    }, 300);
  }

  document.addEventListener("error", function (event) {
    if (event.target && event.target.tagName === "IMG") retryOnce(event.target);
  }, true);

  document.addEventListener("load", function (event) {
    if (!event.target || event.target.tagName !== "IMG" || !event.target.naturalWidth) return;
    event.target.removeAttribute("data-hymnart-retry-failed");
  }, true);
})();


/* ZionArt live collection routing */
(function () {
  if (window.__zionArtLiveCollectionRouting) return;
  window.__zionArtLiveCollectionRouting = true;

  var liveRoutes = {
    "/collections/all": "/products/qiang-shen-dan-official",
    "/collections/new-jewelry-arrivals": "/collections/new-jewelry-arrivals?view=live",
    "/collections/earrings": "/collections/earrings?view=live",
    "/collections/necklaces": "/collections/necklaces?view=live",
    "/collections/bracelets": "/collections/bracelets?view=live",
    "/collections/rings": "/collections/rings?view=live",
    "/collections/watches": "/collections/watches?view=live"
  };

  function normalizedPath(pathname) {
    return pathname.length > 1 ? pathname.replace(/\/$/, "") : pathname;
  }

  var currentPath = normalizedPath(window.location.pathname.replace(/^\/(?:zh-hans|zh-hant|zh-cn|zh-tw|zh)(?=\/|$)/, "") || "/");
  var currentParams = new URLSearchParams(window.location.search);
  if (liveRoutes[currentPath] && currentParams.get("view") !== "live" && !qsdSigned(new URL(window.location.href))) {
    window.location.replace(qsdLiveHref(liveRoutes[currentPath], new URL(window.location.href)));
    return;
  }

  function rewriteLinks() {
    document.querySelectorAll("a[href]").forEach(function (anchor) {
      var url;
      try {
        url = new URL(anchor.getAttribute("href"), window.location.origin);
      } catch (error) {
        return;
      }
      if (url.origin !== window.location.origin) return;
      var nextHref = liveRoutes[normalizedPath(url.pathname.replace(/^\/(?:zh-hans|zh-hant|zh-cn|zh-tw|zh)(?=\/|$)/, "") || "/")];
      if (nextHref) anchor.setAttribute("href", qsdLiveHref(nextHref, url));
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", rewriteLinks);
  } else {
    rewriteLinks();
  }
})();
/* HymnArt mobile product gallery double-tap zoom guard */
(function () {
  if (window.__hymnartGalleryDoubleTapGuard) return;
  window.__hymnartGalleryDoubleTapGuard = true;

  function galleryButtonFrom(event) {
    var target = event.target;
    return target && target.closest ? target.closest("#MainContent .ao-product-gallery .ao-gallery-button") : null;
  }

  document.addEventListener("dblclick", function (event) {
    if (!galleryButtonFrom(event)) return;
    event.preventDefault();
    event.stopPropagation();
  }, true);

document.addEventListener("touchend", function (event) {
    var button = galleryButtonFrom(event);
    if (!button) return;

    var now = Date.now();
    var lastTap = Number(button.getAttribute("data-ao-last-tap") || 0);
    button.setAttribute("data-ao-last-tap", String(now));

    if (now - lastTap > 0 && now - lastTap < 360) {
      event.preventDefault();
      event.stopPropagation();
      button.click();
    }
  }, { capture: true, passive: false });
})();

/* Lucmint sticky product purchase bar */
(function () {
  if (window.__lucmintStickyProductBar) return;
  window.__lucmintStickyProductBar = true;

  function initStickyProductBar() {
    var bar = document.querySelector("[data-sticky-product-bar]");
    if (!bar) return;

    var button = bar.querySelector("[data-sticky-add-to-cart]");
    var price = bar.querySelector(".za-sticky-product-bar__price");
    var variantText = bar.querySelector(".za-sticky-product-bar__meta span");
    var variantSelect = document.querySelector("[data-variant-select]");
    var recommendationFormId = bar.getAttribute("data-sticky-recommendation-form");
    var recommendationForm = recommendationFormId && document.getElementById(recommendationFormId);
    var ticking = false;

    function pageThreshold() {
      var pageHeight = Math.max(
        document.documentElement.scrollHeight || 0,
        document.body ? document.body.scrollHeight : 0
      );
      return Math.max(320, (pageHeight - window.innerHeight) / 3);
    }

    function syncVisibility() {
      ticking = false;
      bar.classList.toggle("is-visible", window.scrollY >= pageThreshold());
    }

    function requestVisibilitySync() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(syncVisibility);
    }

    function mainSubmitButton() {
      return document.querySelector(".za-product-form [data-product-submit], form[action*='/cart/add'] button[type='submit']");
    }

    function syncVariantSummary() {
      if (recommendationForm) return;
      var mainPrice = document.querySelector("[data-product-sale]");
      var submit = mainSubmitButton();
      if (mainPrice && price) price.textContent = mainPrice.textContent.trim();
      if (variantSelect && variantText) {
        var selected = variantSelect.options[variantSelect.selectedIndex];
        var label = selected ? selected.textContent.trim() : "";
        variantText.textContent = label && label !== "Default Title" ? label : "Lucmint Jewelry";
      }
      if (button && submit) {
        button.disabled = submit.disabled;
        button.textContent = submit.disabled ? "Sold Out" : "Add to Cart";
      }
    }

    function addCurrentProductToCart() {
      if (!button || button.disabled) return;
      if (recommendationForm) {
        if (recommendationForm.requestSubmit) recommendationForm.requestSubmit();
        else recommendationForm.submit();
        return;
      }
      var submit = mainSubmitButton();
      if (submit) {
        submit.click();
        return;
      }
      var form = document.querySelector(".za-product-form, form[action*='/cart/add']");
      if (!form) return;
      if (form.requestSubmit) form.requestSubmit();
      else form.submit();
    }

    bar.hidden = false;
    syncVariantSummary();
    requestVisibilitySync();
    window.addEventListener("scroll", requestVisibilitySync, { passive: true });
    window.addEventListener("resize", requestVisibilitySync);
    document.addEventListener("change", function (event) {
      if (event.target && event.target.matches("[data-variant-select], [data-option-input]")) {
        window.setTimeout(syncVariantSummary, 0);
      }
    });
    document.addEventListener("click", function (event) {
      if (event.target && event.target.closest && event.target.closest("[data-option-input] + label")) {
        window.setTimeout(syncVariantSummary, 0);
      }
    });
    if (button) button.addEventListener("click", addCurrentProductToCart);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initStickyProductBar, { once: true });
  } else {
    initStickyProductBar();
  }
})();

/* Keep Shopify chat above the product sticky purchase bar */
(function () {
  if (window.__lucmintProductChatOffset) return;
  window.__lucmintProductChatOffset = true;

  function hasStickyProductBar() {
    return !!document.querySelector("[data-sticky-product-bar]");
  }

  function chatOffsetValue() {
    return window.matchMedia && window.matchMedia("(max-width: 749px)").matches ? "154px" : "118px";
  }

  function applyChatOffset() {
    if (!hasStickyProductBar()) return;
    var offset = chatOffsetValue();
    document.documentElement.style.setProperty("--shopify-chat-activator-offset", offset);
    document.documentElement.style.setProperty("--shopify-agent-activator-offset", offset);
    if (document.body) {
      document.body.style.setProperty("--shopify-chat-activator-offset", offset);
      document.body.style.setProperty("--shopify-agent-activator-offset", offset);
    }
    document.querySelectorAll("shopify-chat, shopify-agent").forEach(function (element) {
      element.style.setProperty("--shopify-chat-activator-offset", offset);
      element.style.setProperty("--shopify-agent-activator-offset", offset);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyChatOffset, { once: true });
  } else {
    applyChatOffset();
  }
  window.addEventListener("resize", applyChatOffset);
  window.setTimeout(applyChatOffset, 800);
})();


})();
